export default {
  name: 'advanced-other-settings'
}
